export default class LoanCalculatorLinking {
  constructor(
    fundingCalculatorService,
    loanProfilerService,
    $localStorage,
    $state,
    contactService,
  ) {
    'ngInject';

    this.fundingCalculatorService = fundingCalculatorService;
    this.loanProfilerService = loanProfilerService;
    this.contactService = contactService;
    this.$localStorage = $localStorage;
    this.$state = $state;

    this.LINKERS = {
      CONTACT: 1,
      OPPORTUNITY: 2,
    };
    /*
      @prop linkerId {int}
      @prop id {id}
    */
    if (!this.$localStorage.currentCalculatorSourceLinker) {
      this.resetLinker();
    } else {
      this.storeLinker(this.$localStorage.currentCalculatorSourceLinker);
    }
  }

  storeLinker(linker) {
    this.$localStorage.currentCalculatorSourceLinker = linker
      ? { ...linker }
      : null;
    this.currentSourceLinker = { ...linker };
  }

  setLinker(linkerData) {
    const {
      linkerId,
      id,
      title,
      previousRouteStateParams,
      isEdit,
      familyId,
      clientIds,
      familyName,
      isBusiness,
      isOpportunityOrLoanapp,
    } = linkerData;
    const obj = Object.assign(
      {},
      {
        linkerId,
        id,
        title,
        isEdit,
        familyId,
        clientIds,
        familyName,
        isBusiness,
        isOpportunityOrLoanapp,
        previousRouteStateParams: previousRouteStateParams
          ? { ...previousRouteStateParams }
          : {},
      },
    );

    this.storeLinker(obj);
  }

  resetLinker() {
    this.storeLinker(null);
  }

  redirectToLoanProfiler(linkerData) {
    const {
      id: paramId,
      tabName,
      eventId,
      familyId,
      previousRouteStateParams,
      proposedLoanAmount,
      securityAmount,
      paramType,
      clientIds,
      primaryPurposeId,
    } = linkerData;
    const loanId = previousRouteStateParams
      ? previousRouteStateParams.loanId
      : null;
    this.setLinker(linkerData);
    const stateParams = {
      brokerEventId: 0,
      loanScenarioId: linkerData.loanApplicationId || 0,
      tab: tabName,
      familyId,
      loanId,
      proposedLoanAmount,
      securityAmount,
      clientIds,
      primaryPurposeId,
    };

    if (eventId) {
      this.$state.go('app.loanProfiler', {
        ...stateParams,
        brokerEventId: eventId,
        paramId,
        paramType,
      });
    } else {
      let brokerEventId = 0;
      this.loanProfilerService
        .getServiceabilityNewBrokerEvent()
        .then((response) => {
          const { data: scopedBrokerEventId } = response;
          if (!scopedBrokerEventId || !stateParams.familyId) {
            return;
          }
          brokerEventId = scopedBrokerEventId;
          return this.loanProfilerService.setFamilyCalculation(
            stateParams.familyId,
            brokerEventId,
          );
        })
        .then((response) => {
          if (!response) {
            return;
          }
          this.$state.go('app.loanProfiler', {
            ...stateParams,
            brokerEventId,
            paramId,
            paramType,
          });
        });
    }
  }

  redirectToFundingCalculator(linkerObj) {
    const { eventId, id, paramType } = linkerObj;
    this.setLinker(linkerObj);
    if (eventId) {
      this.$state.go('app.fundingCalculator', {
        brokerEventId: eventId,
        loanScenarioId: id,
      });
    } else {
      // Get Broker Event Id
      this.fundingCalculatorService
        .getFundingCalculatorNewBrokerEvent()
        .then((response) => {
          this.$state.go('app.fundingCalculator', {
            brokerEventId: response.data,
            paramId: id,
            paramType,
          });
        });
    }
  }

  getcontactFullName(id) {
    return this.contactService.clientInformGet(id).then((clientResponse) => {
      if (clientResponse && clientResponse.data && clientResponse.data.length) {
        const contactDetails = clientResponse.data;
        const contactFullName = contactDetails
          .reduce((accum, item) => {
            if (item.Role === 'Adult') {
              accum.push(`${item.FirstName} ${item.LastName}`);
            }
            return accum;
          }, [])
          .join(' & ');
        return { data: contactFullName };
      }
    });
  }
}
